export default __webpack_public_path__ + "static/media/envelope.359f1a96.svg";